import type { EventName } from "@lit/react";
import { AccordionPanel as AccordionPanelElement, type AccordionPanelEventMap as _AccordionPanelEventMap, } from "@vaadin/accordion/vaadin-accordion-panel.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { AccordionPanelElement, };
export type AccordionPanelEventMap = Readonly<{
    onOpenedChanged: EventName<_AccordionPanelEventMap["opened-changed"]>;
}>;
const events = { onOpenedChanged: "opened-changed" } as AccordionPanelEventMap;
export type AccordionPanelProps = WebComponentProps<AccordionPanelElement, AccordionPanelEventMap>;
export const AccordionPanel = createComponent({
    elementClass: AccordionPanelElement, events, react: React, tagName: "vaadin-accordion-panel"
});
